<template>
    <div class="footer">
        <div v-if="showEmoji" class="emoji">
            <div class="scroll_bar">
                <span @click="chooseEmoji" v-for="emo in emoji" :key="emo.id">{{ emo }}</span>
                <!--        <img style="width:25px" @click="chooseEmoji" alt="" v-for="emo in 63" :src="'./static/image/emoji/'+emo + '.png'" >-->
            </div>
        </div>
        <div class="lenovo" v-if="robotTipsEnable && robotTips.length > 0">
            <div @click="sendRobotTips(lenovo)" v-for="lenovo in robotTips" :key="lenovo.id" v-html="lenovo.tips"></div>
        </div>
        <div id="input" class="scroll_bar" v-model="inputContent" ref="input" @keydown.enter="sendMessage"
             @input="listenerInput" contenteditable :placeholder="$t('DIVInput')"></div>
        <div class="send_div">
            <div class="menu_list">
                <span v-if="userInfo.status === 2" @click="emotionFn()" class="emotion" :title="$t('emoji')"></span>
<!--                <span v-if="initData.leaveMsgMode" @click="messageFn()" class="message"-->
<!--                      :title="$t('leaveMsg')"></span>-->
                <span class="file" v-if="userInfo.status === 2" :title="$t('uploadFile')"><input @change="changeFile"
                                                                                                 ref="file"
                                                                                                 type="file"/></span>
<!--                <span v-if="!!(initData.evaluateMode * 1)" @click="evaluateFn()" class="evaluate"-->
<!--                      :title="$t('evaluate')"></span>-->
                <span v-if="userInfo.status === 2" @click="screenFn()" class="screen"
                      :title="$t('screen')"></span>
                <p v-if="userInfo.status === 2 && initData.videoFlag === 1" class="phoneBackground" title="语音聊天"
                   @click="videoChat(1)"></p>
                <p v-if="userInfo.status === 2 && initData.videoFlag === 1" class="videoBackground" title="视频聊天"
                   @click="videoChat(2)"></p>
            </div>
            <button :style="{ background: `linear-gradient(to right,  ${initData.mainColor})` }" :disabled="!enableSend"
                    @click="sendMessage">
                {{ $t("sendBtn") }}
            </button>
        </div>
        <div class="chatOut" v-if="!chatStatus">
            <!-- <span
                          v-if="!!(initData.workorderMode*1)"
                          @click="messageFn()"
                        >
                          <a
                            class="icon"
                            style="width:20px;height:20px;margin-bottom: 5px"
                          >
                            <svg
                              t="1641726401273"
                              style="width:20px;height:20px"
                              class="icon"
                              viewBox="0 0 1250 1024"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              p-id="2158"
                              width="16"
                              height="16"
                            >
                              <path
                                d="M1193.638811 283.375538a56.839943 56.839943 0 0 1 56.839943 56.839943L1250.933474 852.599151H1250.478754v56.839943a113.679887 113.679887 0 0 1-113.679886 113.679887h-60.39244l-902.334101 0.426299V1023.118981H113.679887a113.395687 113.395687 0 0 1-113.168328-108.649552L0 113.196747A113.395687 113.395687 0 0 1 108.535872 0.511559L1137.225167 0a113.310427 113.310427 0 0 1 107.995893 81.309539 57.522023 57.522023 0 0 1-10.77117 15.858344s0 0.19894-0.198939 0.2842L672.78599 601.309761a39.78796 39.78796 0 0 1-28.419972 21.087619 56.839943 56.839943 0 0 1-61.614498-12.476368 53.770586 53.770586 0 0 1-6.792374-10.231189l-332.513668-275.673726a56.839943 56.839943 0 0 1 80.400099-80.4001l300.143321 248.987372L1046.195998 113.679887l-861.636702 0.397879c-57.863062 1.989398-68.804751 12.931087-70.794149 70.19733l0.397879 667.244096c2.841997 48.313952 15.517305 56.271544 70.16891 57.578862l-70.14049-0.454719v1.222059l1023.118981-0.45472v-0.767339l-81.281119 0.511559c79.121201-1.449419 81.167439-13.471067 81.195859-110.04213L1136.798868 340.215481a56.839943 56.839943 0 0 1 56.839943-56.839943zM148.210152 114.163026H113.679887v0.19894z m36.093364 795.020288l44.391996 0.2842c-17.336183-0.02842-31.830368-0.02842-44.363576-0.2842z"
                                p-id="2159"
                                fill="#dbdbdb"
                              ></path>
                            </svg> </a>
                          <a>留言</a>
                        </span> -->
            <span @click="closeChat">
        <a class="icon">
          <svg t="1641725674189" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
               p-id="1880" width="64" height="64">
            <path
                d="M800 704v17.888h-184.128c-29.664 0-61.184 18.848-74.912 44.832L512 821.44l-28.96-54.752c-13.728-25.952-45.248-44.8-74.912-44.8H224V256h576v448z m5.312-512H218.688C186.336 192 160 219.488 160 253.248v471.392c0 33.76 26.4 61.248 58.816 61.248h189.312c5.92 0 15.712 5.728 18.368 10.752l38.048 71.968 2.912 4.544c11.168 14.528 27.392 22.848 44.544 22.848 17.152 0 33.376-8.32 44.544-22.848l40.96-76.512c2.464-4.608 11.968-10.752 18.368-10.752h189.472c32.352 0 58.656-27.488 58.656-61.248V253.248C864 219.488 837.664 192 805.312 192z"
                p-id="1881" fill="#dbdbdb"></path>
            <path
                d="M336 448c-12.352 0-23.488 4.8-32 12.448A47.68 47.68 0 0 0 288 496c0 14.176 6.24 26.752 16 35.552a47.68 47.68 0 0 0 32 12.448 48 48 0 0 0 0-96M688 448a48 48 0 0 0 0 96c12.352 0 23.488-4.8 32-12.448 9.76-8.8 16-21.376 16-35.552a47.68 47.68 0 0 0-16-35.552 47.68 47.68 0 0 0-32-12.448M512 448c-12.352 0-23.488 4.8-32 12.448a47.68 47.68 0 0 0-16 35.552c0 14.176 6.24 26.752 16 35.552A47.68 47.68 0 0 0 512 544c12.352 0 23.488-4.8 32-12.448 9.76-8.8 16-21.376 16-35.552a47.68 47.68 0 0 0-16-35.552A47.68 47.68 0 0 0 512 448"
                p-id="1882" fill="#dbdbdb"></path>
          </svg>
        </a>
        <a>{{ $t("reChat") }}</a>
      </span>
<!--            <span v-if="!!(initData.evaluateMode * 1)" @click="evaluateFn()">-->
<!--        <a class="icon">-->
<!--          <svg t="1641727265972" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"-->
<!--               p-id="3920" width="64" height="64">-->
<!--            <path-->
<!--                d="M841.900615 408.186609 664.015206 408.186609c-4.087085 0-7.605212-1.823532-9.635451-4.979408-2.044566-3.188622-2.387373-6.788613-0.932232-10.313903 10.105149-19.105127 57.494459-115.41052 44.899606-217.797421-3.51915-28.749788-18.948561-67.455321-72.482825-88.576361-13.886265-5.465478-39.682791-8.026814-59.192124-8.601912-46.860261-1.38044-56.329936 7.693216-60.373019 11.568477-0.164752 0.155543-0.324388 0.316202-0.484024 0.476861C490.730581 105.371886 491.958548 127.455857 493.514997 155.415652c0.795109 14.287401 1.694595 30.466895 0.857531 48.953945-4.579295 49.570999-11.171434 76.334549-24.283056 98.636484-40.689724 69.270666-109.423155 104.141872-122.656551 105.213273l-96.509031 0L86.587054 408.219355c-11.761881 0-21.296025 9.534144-21.296025 21.296025L65.291029 844.261383c0 11.760858 9.534144 21.296025 21.296025 21.296025l164.337859 0c0.858554 0 1.700735-0.065492 2.533706-0.164752l104.601336 0c1.191128 0.969071 2.534729 2.081405 3.739161 3.082198 22.952758 19.025309 83.921341 69.563332 184.571692 69.563332l209.634508 0c53.634548 0 96.863095-29.224602 112.819508-76.270081 0.13917-0.409322 0.26606-0.823761 0.38067-1.24127 2.246157-8.247848 8.025791-25.420973 15.344476-47.162136 27.735691-82.408895 74.159-220.339314 74.159-294.15653C958.708971 446.576965 918.317029 408.186609 841.900615 408.186609zM107.883079 450.812429l121.744785 0 0 372.152928L107.883079 822.965357 107.883079 450.812429zM844.182588 799.778262c-7.649214 22.723537-13.225209 39.289841-15.882736 48.862871-10.205433 29.319769-37.183877 46.803979-72.293513 46.803979l-209.634508 0c-85.292572 0-135.816269-41.879829-157.38961-59.763129-9.691733-8.03193-15.541975-12.881378-24.845874-12.881378l-91.914386 0L272.221962 450.812429l75.364455 0c20.070104 0 51.52142-17.555841 74.262354-33.985022 24.394596-17.623379 58.936297-47.932686 84.96409-92.242867 19.039635-32.386618 25.602098-68.703755 30.019711-116.802216 0.029676-0.317225 0.051165-0.63445 0.066515-0.952698 0.975211-20.862143-0.039909-39.114856-0.855484-53.780881-0.63445-11.403724-1.402953-25.209148-0.179079-31.395034 15.941064-3.081175 61.369719-0.632403 74.387197 4.490268 27.712155 10.934027 42.701544 28.639271 45.822628 54.138014 11.341303 92.193749-35.07689 182.903703-40.407292 192.944384-0.493234 0.932232-0.74906 1.486864-0.74906 1.486864-7.703449 16.70138-6.353708 35.947723 3.624551 51.509141 9.889231 15.376199 26.888394 24.556279 45.473681 24.556279l177.88541 0c52.712549 0 74.215282 19.825534 74.215282 68.429509C916.115897 586.05053 869.322152 725.084073 844.182588 799.778262z"-->
<!--                p-id="3921" fill="#dbdbdb"></path>-->
<!--          </svg>-->
<!--        </a>-->
<!--        <a>{{ $t("evaluate") }}</a>-->
<!--      </span>-->
        </div>

        <!-- v-if="videoShow" -->
        <div class="functionButtonBoxs" v-if="videoShow" id="movementVideo">
            <el-row>
                <el-col
                    :span="24"
                    v-for="(o, index) in 1"
                    :key="o"
                    :offset="index > 0 ? 1 : 0"
                >
                    <el-card :body-style="{ padding: '0px' }">
                        <video id="video" class="videoShow" v-if="communiCate"></video>
                        <div v-if="!communiCate">
                            <div class="Brand">
                <span class="spanWebkit" id="spanWebkit"
                >正在语音通话中...</span
                >
                            </div>
                        </div>
                        <div style="padding: 3px 14px;" class="cardOperation">
                            <div
                                class="videoSound"
                                @click="VoicesoundShow(1)"
                                v-if="soundShow"
                                title="关闭麦克风"
                            ></div>
                            <div
                                class="muteVideoSound"
                                @click="VoicesoundShow(2)"
                                v-else
                                title="开启麦克风"
                            ></div>
                            <div class="boxss">
                                <div
                                    class="pip"
                                    @click="openPip"
                                    title="开启画中画"
                                    v-if="communiCate"
                                ></div>
                                <div v-else class="pip2"></div>
                            </div>


                            <div
                                class="voicePhone"
                                @click="cutCommunicate"
                                v-if="videoType != 1 && communiCate && videoCallType != 1"
                                title="切换语音通话"
                            ></div>
                            <div class="voicePhones" v-else></div>
                            <div class="finish" @click="hangupCall" title="挂断"></div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <el-dialog class="dialog" :append-to-body="true" :visible.sync="showScreen" :close-on-click-modal="false"
                   :title="$t('screen')">
            <div class="screen-tips">
                <h5>电脑自带截屏快捷组合键</h5>
                <p>1.Window系统可以使用 Window键 + Shift键 + s键</p>
                <p>2.mac系统可以使用 Command键 + Shift键 + 3键</p>
                <h5>其它截屏方式</h5>
                <p>1.Windows系统下载截图插件 <a target="_blank"
                                        href="https://ccyun.oss-cn-beijing.aliyuncs.com/static/tool/win.exe">下载</a> <a
                    target="_blank" href="https://jingyan.baidu.com/article/2fb0ba408a1e1300f2ec5f03.html">使用说明</a></p>
                <p>2.Mac系统下载截图插件 <a target="_blank"
                                    href="https://ccyun.oss-cn-beijing.aliyuncs.com/static/tool/mac.dmg">下载</a> <a
                    href="https://jingyan.baidu.com/article/3d69c5514e44a3f0ce02d751.html" target="_blank">使用说明</a></p>
            </div>
        </el-dialog>
        <el-dialog width="600" title="是否要发送图片" :append-to-body="true" :visible.sync="showImgDialog"
                   :close-on-click-modal="false">
            <div class="img-send">
                <img style="max-width: 100%" :src="showImg" alt="">
            </div>
            <div>
                <el-button size="mini" type="primary" @click="sendImg" :loading="isLoading"> 确定</el-button>
                <el-button size="mini" @click="showImgDialog=false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import chatApi from "../methods";
import emoji from "../../api/emoji";
import request from "../../api/request";
import {Toast} from "mint-ui";
import store from "../../store";
import callAPI from "../rongVideo";
import videoCallUrl from "../../../static/media/videoCall.mp3";

import urlParams from "../../api/urlParams";

export default {
    name: "footerpc",
    data() {
        return {
            pipOpen: false, //控制画中画
            videoType: "",
            enableSend: false,
            showScreen: false,
            enableTyping: true,
            showEmoji: false,
            inputContent: "",
            emoji: emoji,
            setTimeoutId: "",
            formData: {},
            soundShow: true,
            communiCate: true,
            isLoading: false,
            videoCallAudio: null,
            isIframe: false,
            showImgDialog: false,
            showImg: '',

        };
    },
    mounted() {
        window.addEventListener('click', this.movementVideoClick)
        try {
            document.getElementById("input").addEventListener("paste", (event) => {
                event.preventDefault();
                let text;
                let clp = (event.originalEvent || event).clipboardData;
                console.log(clp)
                // 兼容针对于opera ie等浏览器
                if (clp === undefined || clp === null) {
                    text = window.clipboardData.getData("text") || "";
                    if (text !== "") {
                        if (window.getSelection) {
                            // 针对于ie11 10 9 safari
                            let newNode = document.createElement("span");
                            newNode.innerHTML = text;
                            window.getSelection().getRangeAt(0).insertNode(newNode);
                        } else {
                            // 兼容ie10 9 8 7 6 5
                            document.selection.createRange().pasteHTML(text);
                        }
                    }
                    console.log('text')
                } else {
                    // 兼容chorme或hotfire
                    text = clp.getData("text/plain") || "";
                    if (text !== "") {
                        document.execCommand("insertText", false, text);
                    } else {
                        let data = event.clipboardData || window.clipboardData;
                        let items = data.items;
                        let fileList = [];
                        if (items && data.files.length) {
                            event.preventDefault();
                            for (let i = 0; i < items.length; i++) {
                                fileList.push(items[i].getAsFile());
                            }
                            let base64Img = null;
                            if (fileList[0]) {
                                base64Img = new Blob([fileList[0]]);
                            } else if (fileList[1]) {
                                base64Img = new Blob([fileList[1]]);
                            }
                            let reader = new FileReader();
                            reader.onload = (event) => {
                                this.showImg = event.target.result;
                                this.showImgDialog = true;
                            };
                            reader.readAsDataURL(base64Img);
                        }
                    }
                }
            });
        } catch (e) {
            console.log('复制', e)
        }

        if (urlParams("from") === "iframe") {
            this.isIframe = true;
        }
    },
    methods: {
        //视频移动
        movementVideoClick() {
            var oDiv = document.getElementById("movementVideo"); //获取这个div
            var disX = 0; //鼠标距离div的边的横向距离
            var disY = 0; //鼠标距离div的边的纵向距离
            if (oDiv) {
                oDiv.onmousedown = function (ev) {
                    var oEvent = ev || event;
                    disX = oEvent.clientX - oDiv.offsetLeft;
                    disY = oEvent.clientY - oDiv.offsetTop;
                    document.onmousemove = function (ev) {
                        var oEvent = ev || event;
                        var l = oEvent.clientX - disX; //div的左坐标
                        var t = oEvent.clientY - disY; //右坐标
                        //div要拖出可视区左侧时：
                        if (l < 0) {
                            l = 0;
                        }
                            //div要拖出可视区右侧时：
                        //document.documentElement.clientWidth 可视区的宽度
                        else if (
                            l >
                            document.documentElement.clientWidth - oDiv.offsetWidth
                        ) {
                            l = document.documentElement.clientWidth - oDiv.offsetWidth;
                        }
                        //div要拖出可视区上边时：
                        if (t < 0) {
                            t = 0;
                        }
                        //div要拖出可视区下边时：
                        if (t > document.documentElement.clientHeight - oDiv.offsetHeight) {
                            t = document.documentElement.clientHeight - oDiv.offsetHeight;
                        }

                        oDiv.style.left = l + "px";
                        oDiv.style.top = t + "px";
                    };
                    document.onmouseup = function () {
                        document.onmousemove = null;
                        document.onmouseup = null;
                    };
                    return false; //阻止默认事件
                };
            }
        },
        //开启画中画
        openPip() {
            this.pipOpen = true;
            let video = document.getElementById("video");
            video.requestPictureInPicture();
        },
        //切换为语音
        cutCommunicate() {
            if (this.pipOpen) {
                this.pipOpen = false;
                document.exitPictureInPicture();
            }
            this.communiCate = false;
            callAPI.callDescendAbility();
        },
        //切换静音
        VoicesoundShow(m) {
            this.soundShow = !this.soundShow;
            if (m === 1) {
                //关闭
                callAPI.callDisableAudioTrack();
            } else if (m === 2) {
                //开启
                callAPI.callEnableAudioTrack();
            }
        },
        //复制图片 上传发送
        sendImg() {
            this.isLoading = true;
            let param = {
                imgData: this.showImg.replace(
                    new RegExp("application/octet-stream", "gm"),
                    "image/png"
                ),
                userId: store.state.userInfo.userId,
            };
            request.uploadFileBase64(param).then((result) => {
                if (result.code === 200) {
                    const message = {
                        msgContent: result.data.url,
                        msgType: 2, //1.文字，2图片，3富文本，4文件，5音频，6视频
                        id: 'file' + new Date().getTime(),
                        msgTime: new Date().getTime(),
                        senderType: 1,
                        fileName: '截图',
                        status: 'loading'
                    };
                    this.$store.dispatch("setChatList", message);
                    //调接口发送出去
                    chatApi.sendMessage(message);

                    this.showImgDialog = false;
                    this.showImg = "";
                    this.isLoading = false;
                }
            });
        },
        //挂断电话时间
        hangupCall() {
            callAPI.callHungup();
            this.$message("已结束通话");
        },
        //拨打视频通话的事件
        videoChat(videoType) {
            //2视频 1语音
            let userSelectType = videoType === 2 ? "视频" : "语音";
            this.$confirm(`是否对客服发起一个${userSelectType}通话？`, "音视频通话", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "success",
            })
                .then(() => {
                    request.engagedLine({userId: store.state.customer.adminId,})
                        .then((res) => {
                            let boolean = res.data;
                            if (boolean === true) {
                                //不忙线
                                callAPI.initIM(1);
                                this.videoCallAudio = new Audio(videoCallUrl);
                                this.videoCallAudio.play();
                                this.videoType = videoType;
                                request.informVideo({userId: store.state.userInfo.userId,videoType: this.videoType,}).then((r) => {});
    
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: "客服正在忙线中，请稍后再拨",
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        closeChat() {
            window.location.reload();
        },
        // 监听输入
        listenerInput(e) {
            if (this.$refs.input.textContent.length > 0) {
                this.enableSend = true;
            }
            // 是否显示正在输入 只有客服的时候才有  是否显示机器人联想
            if (this.enableTyping || this.robotTipsEnable) {
                if (this.setTimeoutId) {
                    clearTimeout(this.setTimeoutId);
                    this.setTimeoutId = null;
                }
                let html = this.$refs.input.textContent;
                this.setTimeoutId = setTimeout(() => {
                    let param = {};
                    if (this.userInfo.status === 2) {
                        // 人工的时候是 输入提示
                        param.msgContent = html;
                        chatApi.userTyping(param);
                    } else if (this.userInfo.status === 1 || this.userInfo.status === 0) {
                        //  机器人的时候是输入联想
                        if (this.$refs.input.textContent) {
                            param.question = this.$refs.input.textContent;
                            chatApi.robotTips(param);
                        } else {
                            // 清空联想
                            this.$store.dispatch("setRobotTips", []);
                        }
                    }
                }, 500);
            }
        },
        // 发消息
        sendMessage(event) {
            this.showEmoji = false;
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            if (this.$refs.input.innerText.replace(/\s+/g, "").length <= 0) return;
            const obj = {
                actor: "",
                msgContent: this.$refs.input.innerHTML,
                senderType: 1, // 发送人 1用户，2客服，3机器人
                date: new Date().getTime(),
                msgTime: new Date().getTime(),
                sysType: "", // 系统消息类型
                msgType: 1, // 消息类型 1文本
                status: "loading", // 消息状态 成功后隐藏否则一直loading
                id: "message" + new Date().getTime(),
            };
            this.$refs.input.innerHTML = "";
            let res = "";
            let fn = function (msg) {
                let reg =
                    /^(((https):\/\/)(www))[a-zA-Z0-9_\-]+((\.(com|cn|org))|(:[0-9]{2,4}))?(:[0-9]{2,4})?([:\/\(\)\?\.&\-=a-zA-Z0-9;#%_]+)?$/g;
                if (msg.match(reg)) {
                    if (!msg.match(reg)) {
                        msg =
                            '<a href="http://' + msg + '" target="_blank">' + msg + "</a>";
                    } else {
                        msg = '<a href="' + msg + '" target="_blank">' + msg + "</a>";
                    }
                } else {
                    let reg1 =
                        /((https?):\/\/)[a-zA-Z0-9_\-]+((\.(com|cn|org))|(:[0-9]{2,4}))?(:[0-9]{2,4})?([:\/\(\)\?\.&\-=a-zA-Z0-9;#%_]+)?/g;
                    let arr = msg.match(reg1);
                    let ret = "";
                    if (arr && arr.length > 0) {
                        let n = arr[0];
                        //取出第一项的匹配
                        let indexNo = msg.indexOf(n);
                        //是否有 http开头
                        let isHttpNo = n.indexOf("http");
                        if (isHttpNo >= 0) {
                            ret = '<a href="' + n + '" target="_blank">' + n + "</a>";
                        } else {
                            ret = '<a href="http://' + n + '" target="_blank">' + n + "</a>";
                        }
                        if (indexNo === 0) {
                            msg = ret + msg.substring(n.length, msg.length);
                        } else {
                            let a = msg.substring(0, indexNo);
                            let b = a + n;
                            let c = msg.substring(b.length, msg.length);
                            msg = a + ret + c;
                            console.log(msg);
                            console.log(this);
                        }
                    }
                }
                return msg;
            };
            res = fn(obj.msgContent);
            obj.msgContent = res;
            // 发送按钮是否可用
            this.enableSend = !this.enableSend;
            // 更新聊天消息
            this.$store.dispatch("setChatList", obj);
            this.$store.dispatch("setScrollBottom");
            //调接口发送出去
            chatApi.sendMessage(obj);
        },
        // 显示评价弹框
        evaluateFn() {
            // 没有咨询过不能评价
            if (this.$store.state.enableEvaluate) {
                chatApi.getEvaluateMsg(() => {
                    this.$store.dispatch("setConfigPc", [
                        {key: "showModal", value: true},
                        {
                            key: "evaluateModal",
                            value: true,
                        },
                    ]);
                });
            } else {
                let obj = {
                    senderType: 4, // 消息类型 1文本
                    msgContent: this.$t("chatAfterEva"),
                };
                this.$store.dispatch("setChatList", obj);
                this.$store.dispatch("setScrollBottom");
            }
        },

        //   显示截屏信息
        screenFn() {
            this.showScreen = true;
        },

        // 显示留言弹框
        messageFn() {
            // this.$store.dispatch("setConfigPc", [
            //   { key: "showModal", value: true },
            //   { key: "messageModal", value: true },
            // ]);
            if (this.isIframe) {
                this.$router.push(
                    "/leaveMessage" +
                    "?channelId=" +
                    this.$route.query.channelId +
                    "&tenantId=" +
                    store.state.initData.tenantId +
                    "&userId=" +
                    store.state.userInfo.userId +
                    "&from=iframe"
                );
            } else {
                this.$router.push(
                    "/leaveMsg" +
                    "?channelId=" +
                    this.$route.query.channelId +
                    "&tenantId=" +
                    store.state.initData.tenantId +
                    "&userId=" +
                    store.state.userInfo.userId
                );
            }
        },
        // 显示表情
        emotionFn() {
            this.showEmoji = !this.showEmoji;
        },
        // 选择表情
        chooseEmoji(event) {
            this.$refs.input.innerHTML += event.target.innerHTML;
            this.enableSend = true;
            this.showEmoji = false;
        },
        // 转人工
        transfer() {
            chatApi.chatForm();
        },
        //上传文件
        changeFile(file) {
            const files = file.target.files[0]; //获取文件
            chatApi.uploadFile(files);
            setTimeout(() => {
                this.$refs.file.value = "";
            }, 1000);
        },
        /// 发送联想
        sendRobotTips(tips) {
            const obj = {
                docId: tips.docId,
                click: 2,
                score: tips.score,
                msgContent: tips.question,
                senderType: 1, // 发送人 1用户，2客服，3机器人
                date: new Date().getTime(),
                msgType: 1, // 消息类型 1文本
                status: "loading", // 消息状态 成功后隐藏否则一直loading
                id: "message" + new Date().getTime(),
            };
            this.$refs.input.innerHTML = "";
            // 更新聊天消息
            this.$store.dispatch("setChatList", obj);
            chatApi.sendMessage(obj);
        },
    },
    computed: {
        engagedLine() {
            return this.$store.state.engagedLine;
        },
        callingUserId() {
            return this.$store.state.callingUserId;
        },
        videoCallType() {
            return this.$store.state.videoCallType;
        },
        videoShow() {
            return this.$store.state.videoShow;
        },
        error() {
            return this.$store.state.error;
        },
        videoAdminId() {
            return this.$store.state.videoAdminId;
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
        chatStatus() {
            return this.$store.state.chatStatus;
        },
        robotTipsEnable() {
            return this.$store.state.robotTipsEnable;
        },
        robotTips() {
            return this.$store.state.robotTips;
        },
        initData() {
            return this.$store.state.initData;
        },
    },
    watch: {
        voiceUserId(val) {
            if (val) {
                request.informVideo({userId: store.state.voiceUserId,videoType: this.videoType,}).then((r) => {});
            }
        },
        videoAdminId() {
            callAPI.call(this.videoType);
        },
        error() {
            this.$notify({
                title: "提示",
                message: "抱歉,客服拒绝了您的会话请求",
                type: "warning",
                duration: 0,
            });
        },
        chatStatus() {
            return this.$store.state.chatStatus;
        },
        userInfo(val) {
            if (val) {
                // callAPI.initIM(1);
            }
            return this.$store.state.userInfo;
        },
        inputContent(newVal, oldVal) {
            console.log(newVal, oldVal);
        },
    },
    beforeDestroy() {
        window.removeEventListener('click', this.movementVideoClick)
        if (chatApi.intervalId) {
            clearTimeout(chatApi.intervalId);
        }
    },
};
</script>

<style scoped>
/* .callPadding{
        position: fixed;
        bottom: 290px;
        right: 900px;
        color: #7467f0;
    } */
.functionButtonBox {
    width: 180px;
    height: 30px;
    position: fixed;
    top: 170px;
    right: 455px;
    background: #817f7f;
    border-radius: 5px;
}

.img-send {
    text-align: center;
    margin-top: 15px;
}

.img-send + div {
    text-align: right;
}

.menu_list span.screen {
    width: 20px;
    height: 20px;
    display: inline-block;
    background-size: 100% 100%;
    background-image: url("../../../static/image/screen.png");
}

.videoShow {
    width: 200px;
    height: 200px;
    position: fixed;
    top: 180px;
    right: 438px;
}

.videoShows {
    width: 200px;
    height: 200px;
    position: fixed;
    top: 180px;
    right: 700px;
}

.finish {
    cursor: pointer;
    width: 30px;
    height: 30px;
    background: url("../../../static/image/finish.png");
    position: fixed;
    top: 170px;
    right: 500px;
    z-index: 20000;
}

.pip {
    cursor: pointer;
    width: 30px;
    height: 30px;
    background: url("../../../static/image/pip.png");
    position: fixed;
    top: 170px;
    right: 460px;
    z-index: 20000;
}

.videoSound {
    cursor: pointer;
    width: 30px;
    height: 30px;
    background: url("../../../static/image/videoSound.png");
    position: fixed;
    top: 170px;
    right: 590px;
    z-index: 20000;
}

.muteVideoSound {
    cursor: pointer;
    width: 25px;
    height: 25px;
    background: url("../../../static/image/muteSound.png");
    position: fixed;
    top: 171px;
    right: 595px;
    z-index: 20000;
}

.voicePhone {
    cursor: pointer;
    width: 25px;
    height: 25px;
    background: url("../../../static/image/voicePhone.png");
    position: fixed;
    top: 171px;
    right: 550px;
    z-index: 20000;
}

.footer {
    height: 150px;
    /* border-top: 0.5px solid #e6e6e6; */
    position: relative;
}

.chatOut {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 8;
    background: #fdfdfd;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.icon {
    display: inline-block;
    width: 30px;
    height: 30px;
}

.icon + a {
    display: block;
}

.chatOut span {
    padding: 4px;
    color: #848484;
    cursor: pointer;
    width: 30%;
}

.emoji {
    position: absolute;
    top: -123px;
    left: 6px;
    border: 1px solid #e3e3e3;
    padding: 0;
    font-size: 0;
    margin: 0;
    box-shadow: 0 0 2px #dadada;
    border-radius: 4px;
    background: white;
}

.lenovo {
    position: absolute;
    bottom: 156px;
    left: 6px;
    border: 1px solid #edeaea;
    padding: 4px;
    margin: 0;
    -webkit-box-shadow: 0 0 2px #dadada;
    box-shadow: 0 0 2px #fcfcfc;
    border-radius: 4px;
    background: white;
    width: 267px;
    text-align: left;
    font-size: 13px;
    line-height: 19px;
    color: #969696;
}

.lenovo > div {
    max-width: 256px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding: 0 4px;
    cursor: pointer;
    line-height: 25px;
}

.emoji > div {
    width: 234px;
    height: 108px;
    margin: 5px;
}

.emoji > div span {
    width: 33px;
    display: inline-block;
    height: 36px;
    cursor: pointer;
    font-size: 25px;
}

.menus {
    height: 40px;
    display: flex;
    justify-content: space-between;
}

.menu_list {
    flex: 1;
    text-align: left;
    font-size: 0;
    padding-left: 10px;
    width: 400px;
    position: absolute;
}

.menu_list span {
    cursor: pointer;
    display: inline-block;
    margin: 8px 5px;
    width: 20px;
    height: 20px;
    vertical-align: text-top;
    background-image: url("../../../static/image/icon_ui.png");
}

.menu_list .phoneBackground {
    cursor: pointer;
    display: inline-block;
    margin: 2px 1px;
    width: 25px;
    height: 25px;
    vertical-align: text-top;
    background-image: url("../../../static/image/phone.png");
}

.menu_list .videoBackground {

    cursor: pointer;
    display: inline-block;
    margin: 5px 5px;
    width: 25px;
    height: 25px;
    vertical-align: text-top;
    background-image: url("../../../static/image/video.png");
}

span.emotion {
    background-position: -112px -77px;
}

span.emotion:hover {
    background-position: -132px -77px;
}

span.file {
    background-position: -71px -77px;
    overflow: hidden;
}

span.file:hover {
    background-position: -91px -77px;
}

span.file input {
    opacity: 0;
}

span.evaluate {
    background-position: -31px -77px;
}

span.evaluate:hover {
    background-position: -51px -77px;
}

span.message {
    background-position: -191px -96px;
}

span.message:hover {
    background-position: -211px -96px;
}

.transfer {
    cursor: pointer;
    margin: 10px 5px;
    font-size: 14px;
    display: inline-block;
    vertical-align: bottom;
}

div#input {
    padding: 7px 9px 0;
    height: 80px;
    line-height: 18px;
    max-height: 80px;
}

.send_div {
    text-align: right;
    padding-right: 20px;
    margin-top: 10px;
}

.send_div button:disabled {
    background: #e6e6e6;
}

.send_div button {
    width: 60px;
    height: 32px;
    line-height: 30px;
    padding: 0;
    text-align: center;
    font-size: 14px;
    letter-spacing: 2px;
    color: #ffffff;
    background-color: #7467f0;
    border-radius: 5px;
    cursor: pointer;
    border: none;
    outline: none;
}

.screen-tips {
    margin-top: -20px;
    line-height: 23px;
}

.screen-tips h5 {
    margin: 10px;
    color: black;
}

.screen-tips a {
    text-decoration: none;
    color: #5776f1;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/footer.vue